<div class="list-detail">
    <div class="list-detail_col-primary">
        <div class="d-flex align-items-end my-4">
            <svg-icon class="is-cursor" [routerLink]="'/my-list'" src="assets/svg/arrow.svg"></svg-icon>
            <h1 class="list-detail_title"><span>{{idea?.code}} |</span> {{idea?.title}}</h1>
            <div class="register-date">
                <dl>
                    <dt class="list-detail_lbl">Data de Cadastro</dt>
                    <dd class="list-detail_value">{{idea?.createdAt| date:'dd/MM/yyyy'}}</dd>
                </dl>
            </div>
            <span *ngIf="!isNullOrUndefined(idea?.status)" class="item_status text-capitalize" [ngClass]="idea?.status"
                [ngStyle]="{'background': getStatusColors(idea?.status)}">
                <svg-icon src="assets/svg/{{idea?.status}}.svg"></svg-icon>
                {{getTranslate(idea?.status)}}
            </span>
        </div>
        <div class="list-detail_info">
            <dl class="flex-grow-1 px-2">
                <dt class="list-detail_lbl">Idealizador</dt>
                <dd class="list-detail_value">{{idea?.authorName}}</dd>
            </dl>
            <dl class="flex-grow-1 px-2">
                <dt class="list-detail_lbl">RE</dt>
                <dd class="list-detail_value">{{idea?.re}}</dd>
            </dl>
            <dl class="flex-grow-1 px-2">
                <dt class="list-detail_lbl">{{'unity' | translate}}</dt>
                <dd class="list-detail_value">{{idea?.unity?.name}}</dd>
            </dl>
            <dl class="flex-grow-1 px-2">
                <dt class="list-detail_lbl">Cargo</dt>
                <dd class="list-detail_value">{{idea?.role}}</dd>
            </dl>
            <dl class="flex-grow-1 px-2">
                <dt class="list-detail_lbl">Centro de custo</dt>
                <dd class="list-detail_value">{{idea?.costCenter}}</dd>
            </dl>
            <dl class="flex-grow-1 px-2">
                <dt class="list-detail_lbl">Email</dt>
                <dd class="list-detail_value">{{idea?.email}}</dd>
            </dl>
        </div>
        <div *ngIf="!isNullOrUndefined(idea?.authors)" class="participant_title mb-3">
            <div class="divider position-absolute m-0" style="top: 56%;">&nbsp;</div>
            <span>Participantes</span>
        </div>

        <div class="table-responsive">
            <table class="table table_regular">
                <thead>
                    <tr>
                        <th scope="col">Autor</th>
                        <th scope="col">RE</th>
                        <th scope="col">Cargo</th>
                        <th scope="col">Area</th>
                        <th scope="col">Centro de custo</th>
                        <th scope="col">Email</th>
                        <th scope="col">Ativo</th>
                        <th scope="col">Justificativa</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="isNullOrUndefined(idea?.authors)">
                        <td colspan="8" class="text-center" style="padding: 68px 0;"> Nenhum autor encontrado!</td>
                    </tr>
                    <tr *ngFor="let i of idea?.authors; let ind = index">
                        <td>
                            <span class="participant_lbl">{{i.name}}</span>
                        </td>
                        <td>
                            <span class="participant_lbl">{{i.re}}</span>
                        </td>
                        <td>
                            <span class="participant_lbl">{{i.jobRole}}</span>
                        </td>
                        <td>
                            <span class="participant_lbl">{{i.area}}</span>
                        </td>
                        <td>
                            <span class="participant_lbl">{{i.costCenter}}</span>
                        </td>
                        <td>
                            <span class="participant_lbl">{{i.email}}</span>
                        </td>
                        <td>
                            <span class="participant_lbl">{{i.remove ? 'Não' : 'Sim'}}</span>
                        </td>
                        <td>
                            <span (click)="toggleExpand(ind)" class="text-truncate d-inline-block"
                                [ngClass]="{ 'expanded': expandedIndex === ind }" [style.cursor]="'pointer'"
                                [title]="expandedIndex !== i ? i.justification : ''">
                                {{ i.justification ? (i.justification | slice:0:50) + '...' : " "}}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="list-detail_card mt-4" *ngIf="!isIdeaChallenge">
            <p class="list-detail_card_lbl" *ngIf="!isNullOrUndefined(idea?.challenge)">{{idea?.challenge?.title}}</p>
            <p class="list-detail_card_value" *ngIf="!isNullOrUndefined(idea?.challenge)">
                {{idea?.challenge?.description}}
            </p>
            <div class="divider my-2" style="height: 2px" *ngIf="!isNullOrUndefined(idea?.challenge)"></div>
            <div class="d-flex justify-content-between">
                <div class="d-block">
                    <p class="list-detail_card_title mt-3">{{'description' | translate}}</p>
                    <p *ngIf="!isIdeaKaizen" class="list-detail_card_value col-9">{{ideaDescription}}</p>
                    <p id="problem_solution" *ngIf="isIdeaKaizen" class="list-detail_card_value_paragraph col-9">
                        {{problemAndSolution}}</p>
                </div>
                <div class="d-block text-left col-3" *ngIf="idea?.status == 'denied'">
                    <p class="list-detail_card_lbl">{{'motivoreprova' | translate}}</p>
                    <p class="list-detail_card_value">{{!isNullOrUndefined(idea?.motive) ? idea?.motive : "Não foi
                        informado motivo para reprova"}}</p>
                </div>
            </div>
        </div>

        <div class="list-detail_card" *ngIf="!isIdeaChallenge">
            <p class="list-detail_card_title">{{'implementation' | translate}}</p>
            <div class="list-detail_card_implement">
                <dl class="flex-grow-1" *ngIf="!isNullOrUndefined(idea?.unity?.name)">
                    <dt class="list-detail_card_lbl">Local</dt>
                    <dd class="list-detail_card_value">{{idea?.unity?.name}}</dd>
                </dl>
                <dl class="flex-grow-1" *ngIf="!isNullOrUndefined(idea?.areaResponsible)">
                    <dt class="list-detail_card_lbl">Área Principal</dt>
                    <dd class="list-detail_card_value">{{idea?.areaResponsible}}</dd>
                </dl>
                <dl class="flex-grow-1" *ngIf="!isNullOrUndefined(idea?.areaExtensionLine)">
                    <dt class="list-detail_card_lbl">Ramal | Telefone</dt>
                    <dd class="list-detail_card_value">{{idea?.areaExtensionLine}}
                        | {{idea?.phone |mask:'(00) 00000-0000 ||+00 (00) 0000-0000'}}</dd>
                </dl>
                <dl class="flex-grow-1" *ngIf="!isNullOrUndefined(idea?.productiveDescription)">
                    <dt class="list-detail_card_lbl">Equipamento</dt>
                    <dd class="list-detail_card_value"> {{idea?.productiveDescription}}</dd>
                </dl>
            </div>
        </div>

        <div class="list-detail_card mt-4" *ngIf="isIdeaChallenge">
            <p class="list-detail_card_lbl" *ngIf="!isNullOrUndefined(idea?.challenge)">{{idea?.challenge?.title}}</p>
            <p class="list-detail_card_value" *ngIf="!isNullOrUndefined(idea?.challenge)">
                {{idea?.challenge?.description}}
            </p>
            <div class="divider my-2" style="height: 2px" *ngIf="!isNullOrUndefined(idea?.challenge)"></div>
            <div class="d-flex justify-content-between">
                <div class="d-block">
                    <p class="list-detail_card_title">{{'currentProblem' | translate}}</p>
                    <p class="list-detail_card_value col-9">{{idea?.currentProblem}}</p>
                </div>
                <div class="d-block text-left col-3" *ngIf="idea?.status == 'denied'">
                    <p class="list-detail_card_lbl">{{'motivoreprova' | translate}}</p>
                    <p class="list-detail_card_value">{{!isNullOrUndefined(idea?.motive) ? idea?.motive : "Não foi
                        informado motivo para reprova"}}</p>
                </div>
            </div>
        </div>

        <div class="list-detail_card" *ngIf="isIdeaChallenge">
            <p class="list-detail_card_title">{{'ideaSolution' | translate}}</p>
            <p class="list-detail_card_value col-9">{{idea?.problemSolution}}</p>
        </div>

        <div class="list-detail_card" *ngIf="!isNullOrUndefined(idea?.expectations ) && idea?.status !== 'approved'">
            <p class="list-detail_card_title">{{'whatReturn' | translate}}</p>
            <dl class="flex-grow-1" *ngFor="let x of idea?.expectations">
                <dt class="list-detail_card_lbl text-capitalize">{{ getTranslate(x.expectation)}}</dt>
                <dd class="list-detail_card_value mb-5">
                    {{x.expectationDescription}}
                </dd>
            </dl>
        </div>

        <!-- Anexos: sempre visível; adicionar/remover quando canManageFiles -->
        <div class="list-detail_card">
            <p class="list-detail_card_title">{{'attachments.label' | translate}}</p>
            <app-idea-files flow="idea" [ideaId]="paramId" [files]="ideaFiles" [canManage]="canManageFiles"
                (changed)="getIdeaFiles(paramId)"></app-idea-files>
        </div>

        <div class="list-detail_card" *ngIf="!isNullOrUndefined(idea?.implementationResume)">
            <p class="list-detail_card_title d-flex align-items-center">
                <span class="flex-grow-1">{{'summaryImplementation' | translate}}</span>
                <button *ngIf="validateStatus && !idea?.blocked" (click)="onEditIdeaConclusion()"
                    [disabled]="!editAction" class="btn btn-primary p-2">
                    <svg-icon [svgStyle]="{'fill':'white'}" src="assets/svg/edit.svg"></svg-icon>
                </button>
            </p>

            <div class="d-flex mb-4" style="margin-top: 32px;gap: 20px">
                <app-input [title]="'productiviyIncrease' | translate" [info]="productivityVote" [inputType]="'number'"
                    [titleSize]="'medium'" [value]="idea.productivityValueHH" [width]="'50%'">
                </app-input>

                <app-input [title]="'financialReturn' | translate" [info]="financialVote" [inputType]="'text'"
                    [titleSize]="'medium'" [value]="idea.analysisFinacialreturn | currency" [width]="'50%'"
                    (valueChange)="changeInput()">
                </app-input>
            </div>

            <h4 *ngIf="idea?.sustainabilities[0]?.name">
                {{'indicators' | translate}}
            </h4>
            <div class="indicators" *ngFor="let indicator of idea.sustainabilities">
                <app-input [width]="'80%'" [title]="'Indicador'" [inputType]="'text'" [titleSize]="'medium'"
                    [value]="indicator.name">
                </app-input>

                <app-input [width]="'80%'" [title]="'Quantidade'" [inputType]="'text'" [titleSize]="'medium'"
                    [value]="indicator.quantity">
                </app-input>

                <app-input [width]="'80%'" [title]="'Unidade'" [info]="" [inputType]="'text'" [titleSize]="'medium'"
                    [value]="indicator.unity">
                </app-input>

                <app-input [width]="'80%'" [title]="'Pontuação'" [inputType]="'text'" [titleSize]="'medium'"
                    [value]="indicator.pontuation">
                </app-input>
            </div>

            <div class="mt-4 w-50">
                <app-input [title]="'environmentImpact' | translate" [info]="sustainabilityVote" [inputType]="'number'"
                    [titleSize]="'medium'" [value]="idea.sustentabilityPoint">
                </app-input>
            </div>

            <hr>

            <div class="d-flex flex-column flex-sm-row" style="margin-top: 20px;column-gap: 89px;row-gap: 20px">
                <div class="flex-grow-0">
                    <div class="definition-lb">Data da premiação</div>
                    <div class="definition-value" style="font-size: 18px">
                        <svg-icon src="assets/svg/date.svg"></svg-icon>
                        {{idea?.premiationDate|date:'dd/MM/yyyy'}}
                    </div>
                </div>
            </div>
        </div>

        <div class="list-detail_card definition" *ngIf="idea?.father === null  && idea?.status === 'awarded'">
            <p class="list-detail_card_title d-flex align-items-center">Publicação</p>
            <div class="d-flex align-items-center mb-3">
                <svg-icon src="assets\images\country\brazil.svg" style="width: 30px"></svg-icon>
                <p class="list-detail_card_lbl flex-grow-1 text-capitalize ml-3 mb-0">Português</p>
                <a (click)="showModalTranslateESPT(1)" class="btn btn-primary p-2">
                    <svg-icon [svgStyle]="{'fill':'white'}" src="assets/svg/edit.svg"></svg-icon>
                </a>
            </div>
            <dl>
                <dt class="list-detail_card_lbl text-capitalize">Titulo</dt>
                <dd class="list-detail_card_value">{{titleBR}}</dd>
            </dl>
            <dl>
                <dt class="list-detail_card_lbl text-capitalize">{{'description' | translate}}</dt>
                <dd class="list-detail_card_value">{{descriptionBR}}</dd>
            </dl>
            <dl>
                <dt class="list-detail_card_lbl text-capitalize">Resumo da implantação e ganhos</dt>
                <dd class="list-detail_card_value">{{implementationResumeBR}}</dd>
            </dl>
            <div class="list-detail_divider" style="background-color: #8B8B8B">&nbsp;</div>

            <div class="d-flex align-items-center mb-3">
                <svg-icon src="assets\images\country\espanha.svg" [svgStyle]="{'border-radius':'50%'}"
                    style="width: 30px"></svg-icon>
                <p class="list-detail_card_lbl flex-grow-1 text-capitalize ml-3 mb-0">Espanhol</p>
                <a (click)="showModalTranslateESPT(2)" class="btn btn-primary p-2">
                    <svg-icon [svgStyle]="{'fill':'white'}" src="assets/svg/edit.svg"></svg-icon>
                </a>
            </div>

            <dl>
                <dt class="list-detail_card_lbl text-capitalize">Titulo</dt>
                <dd class="list-detail_card_value">{{titleES}}</dd>
            </dl>
            <dl>
                <dt class="list-detail_card_lbl text-capitalize">{{'description' | translate}}</dt>
                <dd class="list-detail_card_value">{{descriptionES}}</dd>
            </dl>
            <dl>
                <dt class="list-detail_card_lbl text-capitalize">Resumo da implantação e ganhos</dt>
                <dd class="list-detail_card_value">{{implementationResumeES}}</dd>
            </dl>
        </div>

        <!--        Definição do comitê-->
        <div class="list-detail_card definition" *ngIf="!isNullOrUndefined(idea?.conclusion)">

            <p class="list-detail_card_title d-flex align-items-center">
                <span class="flex-grow-1">Definição do comitê</span>
            </p>
            <div class="card bg-primary px-5 py-4">
                <div class="d-flex flex-column flex-wrap flex-sm-row align-items-center" style="gap: 50px">
                    <div class="flex-grow-1 d-flex align-items-center " style="gap: 10px">
                        <div class="prize_div">
                            <img class="lottiebg" src="assets/images/lottiebg.png" alt="">
                            <ng-lottie class="lottie" width="140px" [options]="accessAnimation"></ng-lottie>
                            <div class="text-center">
                                <p class="definition-subtitle">Pontuação total</p>
                                <p class="definition-award award-bold">{{idea?.conclusion.points}}<span> Pontos</span>
                                </p>

                                <p class="definition-subtitle">Valor do Prêmio</p>
                                <p class="definition-award award-bold">{{idea?.conclusion.prize | currency}}</p>
                            </div>
                        </div>

                    </div>
                    <div class="flex-grow-1">
                        <h4 class="definition-title">Premiados</h4>
                        <div class="d-flex mb-2 flex-column" style="gap: 10px">
                            <div class="d-flex flex-grow-1 border-bottom pr-2 pb-2">
                                <span class="definition-name">{{idea?.authorName}}</span>
                                <span class="definition-award">{{(idea?.conclusion.prize / (activeAuthors.length + 1)) |
                                    currency}}</span>
                            </div>
                            <div class="d-flex flex-grow-1 border-bottom pr-2 pb-2" *ngFor="let a of activeAuthors">
                                <span class="definition-name">{{a.name}}</span>
                                <span class="definition-award">{{(idea?.conclusion.prize / (activeAuthors.length + 1)) |
                                    currency}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table secondary mt-4">
                    <thead>
                        <tr>
                            <th scope="col"></th>
                            <th scope="col" *ngFor="let i of enumVote">{{getTranslate(i)}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th scope="row">{{'productivityIncrease' | translate}}</th>
                            <td *ngFor="let i of enumVote">
                                <div class="check-definition"
                                    [ngClass]="{'background':idea?.conclusion.productivityVote == i}">&nbsp;
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Sustentabilidade</th>
                            <td *ngFor="let i of enumVote">
                                <div class="check-definition"
                                    [ngClass]="{'background':idea?.conclusion.sustainabilityVote == i}">&nbsp;
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Retorno financeiro</th>
                            <td *ngFor="let i of enumVote">
                                <div class="check-definition"
                                    [ngClass]="{'background':idea?.conclusion.financialVote == i}">&nbsp;
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>

        <div id="comments" *ngIf="isIdeaChallenge">
            <p>Comentários <span *ngIf="inputOfCommentIsDisabled">{{ formatTime(minutes) }}:{{ formatTime(seconds)
                    }}</span></p>

            <div class="input-box">
                <p>Deixe seu comentário aqui</p>
                <input type="text" maxlength="250" placeholder="Digite aqui" [disabled]="inputOfCommentIsDisabled"
                    [(ngModel)]="comment" (keypress)="onComment($event)">
            </div>

            <div class="comments">
                <p>Comentários</p>

                <div class="comment" *ngFor="let comment of allComments">
                    <div>
                        <p>{{comment?.name}}</p>
                        <p>{{ comment?.createdAt | date: 'dd/MM/yyyy' }}</p>
                    </div>
                    <div class="comment-value">{{comment?.message}}</div>
                </div>
            </div>
        </div>

    </div>
    <aside class="list-detail_col-secondary" *ngIf="!idea?.blocked">
        <ng-container *ngIf="!isNullOrUndefined(idea?.status)&&idea?.status == 'received'">
            <h4 class="list-detail_aside_title"> {{'defineEevaluated' | translate}} </h4>
            <p class="list-detail_aside_subtitle">
                {{'selectCommittee' | translate}}
            </p>
            <div class="input-material committee-drop" *ngIf="whichCommitee">
                <ng-multiselect-dropdown id="committee" name="committee" [settings]="committeeDropSettings"
                    [(ngModel)]="committeeSel" [data]="committees"
                    [placeholder]="'committeeDropdown.placeholder' | translate"
                    (onSelect)="onCommitteeSelect($event)" (onDeSelect)="onCommitteeDeSelect()">
                </ng-multiselect-dropdown>
                <label for="committee" class="mb-0 mr-3 disabled">Qual Comitê</label>
            </div>
            <div style="min-height: 14.5em;margin-top: 3em">
                <p class="list-detail_aside_title">Tags</p>
                <div class="d-flex justify-content-between align-items-center">
                    <div class="input-material" style="margin-bottom: 0.5em">
                        <input id="startTag" class="form-control" type="text" #targetTags [(ngModel)]="modelTag"
                            [disabled]="!tags" (keyup.enter)="createTag($event.target.value)" required />
                        <label for="startTag">Nome da tag</label>
                    </div>
                    <a href="javascript:void('');" class="btn btn-primary" (click)="createTag(targetTags.value)">+</a>
                </div>
                <div class="d-flex flex-wrap" style="gap: 5px">
                    <div class="list-detail_tag" *ngFor="let i of acceptIdeaInput.tags">
                        {{i}}
                        <svg-icon class="is-cursor" (click)="actionRemoveTag(i)" src="assets/svg/close.svg"></svg-icon>
                    </div>
                </div>
            </div>
            <div class="list-detail_divider">&nbsp;</div>
            <button [disabled]="!goCommitte" (click)="onAcceptIdea()"
                class="list-detail_aside_btn btn btn-block btn-warning">
                {{'sendCommitte' | translate}}
            </button>
            <button [disabled]="!reproveCommitte" (click)="onReprove(idea?.id)"
                class="list-detail_aside_btn btn btn-block btn-warning">
                {{'denial' | translate}}
            </button>
        </ng-container>

        <ng-container
            *ngIf="!isNullOrUndefined(idea?.status)&&idea?.status != 'received' && idea?.status != 'analysis'">
            <p class="committee-lbl mb-3">Comitê responsável</p>
            <h3 class="committee-title">{{idea?.committee?.name}}</h3>
            <ng-container *ngIf="!isNullOrUndefined(idea?.committee)">
                <p class="committee-lbl mb-2">Participantes</p>
                <div class="d-flex flex-wrap justify-content-start mb-4" style="gap: 5px">
                    <div class="d-flex flex-column align-items-center" data-toggle="tooltip" data-placement="top"
                        [title]="i.name" style="gap:5px; width:30%"
                        *ngFor="let i of idea?.committee?.participants">
                        <img class="committee-img" src="{{i?.photo}}" onerror="this.onerror=null;
                                this.src='https://www.pontoxtecidos.com.br/static/567/sku/164485009798408.jpg';"
                            alt="img" />
                        <span class="committee-name truncate">{{i.name}}</span>
                    </div>
                </div>
                <div class="list-detail_divider">&nbsp;</div>
            </ng-container>
            <ng-container *ngIf="!isNullOrUndefined(idea?.tags)">
                <p class="list-detail_aside_title mt-3">Tags</p>
                <div class="d-flex flex-wrap mb-3" style="gap: 5px">
                    <div class="list-detail_tag px-2" *ngFor="let i of idea?.tags">
                        {{i.tag}}
                    </div>
                </div>
                <div class="list-detail_divider">&nbsp;</div>
            </ng-container>
            <div class="d-flex mt-3">
                <p class="list-detail_aside_title align-items-center flex-grow-1" style="gap: 10px">
                    <svg-icon src="assets/svg/kamban.svg"></svg-icon>
                    {{'actions' | translate}}
                </p>
                <p class="list-detail_aside_title align-items-end">
                    {{idea?.endedAction}}<span>/{{idea?.action ? idea?.action?.length : 0}}</span></p>
            </div>
            <ng-container *ngIf="!isNullOrUndefined(idea?.action)">
                <div class="d-flex border-bottom pt-2 pb-1" *ngFor="let s of actionStatus">
                    <div class="flex-grow-1">{{getTranslate(s)}}</div>
                    <div>{{getActionByType(s).length}}</div>
                </div>
            </ng-container>

            <a [routerLink]="'/actions/'+this.paramId"
                class="list-detail_aside_btn btn btn-block btn-outline-primary mt-3">
                {{'goAction' | translate}}
            </a>
            <div class="list-detail_divider" style="margin: 19px 0 1.5em">&nbsp;</div>
            <button (click)="isIdeaChallenge ? showChallengeModal() : onAnalysis(idea?.id)"
                *ngIf="idea?.status == 'analysis'" [disabled]="!aproveonAnalysis"
                class="list-detail_aside_btn btn btn-block btn-warning">
                {{'novocadastro2.aprovar' | translate}}
            </button>
            <button (click)="onApproved()" *ngIf="idea?.status == 'approved'" [disabled]="!finalizeAction"
                class="list-detail_aside_btn btn btn-block btn-warning">
                {{'finalizeCommittee' | translate}}
            </button>
            <a (click)="onAward()" *ngIf="idea?.status == 'approved_award'"
                class="list-detail_aside_btn btn btn-block btn-primary">
                {{'finishAwards' | translate}}</a>
            <button (click)="onReprove(idea?.id)" [disabled]="!finishAwards"
                *ngIf="idea?.status == 'received'|| idea?.status == 'analysis' || idea?.status == 'denial'"
                class="list-detail_aside_btn btn btn-block btn-outline-danger"> {{idea?.status == 'analysis' ?
                'Reprovado' : 'Reprovar'}}</button>
        </ng-container>
        <ng-container *ngIf="!isNullOrUndefined(idea?.status)&& idea?.status == 'analysis'">
            <p class="committee-lbl mb-2">Comitê responsável</p>
            <select
                [disabled]="!(user.role === 'local-manager' || user.role === 'corporate-manager' || user.role === 'admin')"
                [(ngModel)]="this.committeeUpdate" class="form-control" name="type" (change)="updateCommittee()">
                <option *ngFor="let i of committees" [value]="i.id">{{i.name}}</option>
            </select>
            <ng-container *ngIf="!isNullOrUndefined(idea?.committee)">
                <p class="committee-lbl mb-2">Participantes</p>
                <div class="d-flex flex-wrap justify-content-between mb-4" style="gap: 5px">
                    <div class="d-flex flex-column align-items-center" style="gap:5px"
                        *ngFor="let i of idea?.committee?.participants">
                        <img class="committee-img" alt="img" src="{{i?.photo}}" onerror="this.onerror=null;
                        this.src='https://www.pontoxtecidos.com.br/static/567/sku/164485009798408.jpg';" alt="img" />
                        <span class="committee-name">{{i.name}}</span>
                    </div>
                </div>
                <div class="list-detail_divider">&nbsp;</div>
            </ng-container>
            <ng-container *ngIf="!isNullOrUndefined(idea?.tags)">
                <p class="list-detail_aside_title mt-3">Tags</p>
                <div class="d-flex flex-wrap mb-3" style="gap: 5px">
                    <div class="list-detail_tag px-2" *ngFor="let i of idea?.tags">
                        {{i.tag}}
                    </div>
                </div>
                <div class="list-detail_divider">&nbsp;</div>
            </ng-container>
            <div class="d-flex mt-3">
                <p class="list-detail_aside_title align-items-center flex-grow-1" style="gap: 10px">
                    <svg-icon src="assets/svg/kamban.svg"></svg-icon>
                    {{'actions' | translate}}
                </p>
                <p class="list-detail_aside_title align-items-end">
                    {{idea?.endedAction}}<span>/{{idea?.action ? idea?.action?.length : 0}}</span></p>
            </div>
            <ng-container *ngIf="!isNullOrUndefined(idea?.action)">
                <div class="d-flex border-bottom pt-2 pb-1" *ngFor="let s of actionStatus">
                    <div class="flex-grow-1">{{getTranslate(s)}}</div>
                    <div>{{getActionByType(s).length}}</div>
                </div>
            </ng-container>

            <a [routerLink]="'/actions/'+this.paramId"
                class="list-detail_aside_btn btn btn-block btn-outline-primary mt-3">
                {{'goAction' | translate}}
            </a>
            <div class="list-detail_divider" style="margin: 19px 0 1.5em">&nbsp;</div>
            <button (click)="isIdeaChallenge ? showChallengeModal() : onAnalysis(idea?.id)"
                *ngIf="idea?.status == 'analysis'" [disabled]="!aproveonAnalysis"
                class="list-detail_aside_btn btn btn-block btn-warning">
                {{'novocadastro2.aprovar' | translate}}
            </button>
            <button (click)="onApproved()" *ngIf="idea?.status == 'approved'" [disabled]="!finalizeAction"
                class="list-detail_aside_btn btn btn-block btn-warning">
                {{'finalizeCommittee' | translate}}
            </button>
            <a (click)="onAward()" *ngIf="idea?.status == 'approved_award'"
                class="list-detail_aside_btn btn btn-block btn-primary">
                {{'finishAwards' | translate}}</a>
            <button (click)="onReprove(idea?.id)" [disabled]="!finishAwards"
                *ngIf="idea?.status == 'received'|| idea?.status == 'analysis' || idea?.status == 'denial'"
                class="list-detail_aside_btn btn btn-block btn-outline-danger"> {{idea?.status == 'analysis' ?
                'Reprovar' : 'Reprovado'}}</button>
        </ng-container>

        <div class="list-detail_divider">&nbsp;</div>

        <div *ngIf="user.role === 'corporate-manager'" class="new_code_div">
            <label for="newCode">Novo código</label>
            <input id="newCode" class="form-control" type="text" [(ngModel)]="newCode" required />
            <button (click)="updateCode()" class="list-detail_aside_btn btn btn-block btn-warning">
                {{'updateCode' | translate}}
            </button>
        </div>

    </aside>
</div>

<div class="modal-custom modal fade" id="ModalResume" data-keyboard="false" data-backdrop="static" role="dialog"
    aria-labelledby="modalNoteResumeLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content p-0">
            <div class="modal-header align-items-center bg-gray" style="min-height: 107px;"
                (click)="closeModalResume()">
                <h2 class="modal-title">{{'describeImplementation' | translate}}</h2>
                <a class="modal_close">
                    <svg-icon src="assets/svg/close-modal.svg"></svg-icon>
                </a>
            </div>

            <div class="modal-body p-3 p-md-4">
                <div class="input-material p-3 mb-4">

                    <input [(ngModel)]="approveIdea.title" id="ideaTitle" class="form-control" name="ideaTitle" />

                    <label for="ideaTitle" class="mb-0 mr-3">
                        {{'aproveIdeaModal.ideaTitle' | translate}}
                    </label>
                </div>

                <div class="input-material p-3 mb-4">
                    <textarea [(ngModel)]="approveIdea.implementationResume" rows="6" id="unity" class="form-control"
                        name="type">
                    </textarea>
                    <label for="unity" class="mb-0 mr-3">{{'description' | translate}}</label>
                </div>

                <div class="d-flex selects-conatiners">
                    <div class="input-material w-100">
                        <select id="unity" class="form-control" name="unity" [(ngModel)]="approveIdeaInput.unity"
                            (change)="onUpdateIdea({unity: {id: approveIdeaInput.unity}})">
                            <option [ngValue]="undefined">Selecione</option>
                            <option *ngFor="let unity of unitiesResult" [value]="unity.id">{{unity?.name}}</option>
                        </select>
                        <label for="unity" class="mb-0 mr-3">Unidade</label>
                    </div>

                    <div class="input-material w-100">
                        <select id="committe" class="form-control" name="committe"
                            [(ngModel)]="approveIdeaInput.committee" (change)="onCommitteeChange()">
                            <option [ngValue]="undefined">Selecione</option>
                            <option *ngFor="let committee of committees" [value]="committee.id">{{committee?.name}}
                            </option>
                        </select>
                        <label for="committe" class="mb-0 mr-3">Comitê</label>
                    </div>
                </div>
                <app-authors [authorsRe]="ideaAuthors"
                    (getInforsOfFormAuthors)="getInforsOfFormAuthors($event)"></app-authors>
                <!-- <app-aprove-idea-authors
                    [authors]="ideaAuthors"
                    (newAuthorsChange)="onNewAuthorsChange($event)"
                    (authorChangeReason)="onAuthorChangeReason($event)"
                >
                </app-aprove-idea-authors> -->

                <div class="input-material p-3 mb-4">
                    <label for="sustainabilityReason" class="mb-0 mr-3">
                        {{'aproveIdeaModal.sustainabilityReason' | translate}}
                    </label>
                    <textarea rows="6" id="sustainabilityReason" class="form-control" name="sustainabilityReason"
                        [(ngModel)]="ideaConclusion.sustainabilityVoteDescription">
                    </textarea>
                </div>

                <div class="input-material p-3 mb-4">
                    <label for="financialReason" class="mb-0 mr-3">
                        {{'aproveIdeaModal.financialReason' | translate}}
                    </label>
                    <textarea rows="6" id="financialReason" class="form-control" name="financialReason"
                        [(ngModel)]="ideaConclusion.financialVoteDescription">
                    </textarea>
                </div>

                <div class="input-material p-3 mb-4">
                    <label for="productiveReason" class="mb-0 mr-3">
                        {{'aproveIdeaModal.productiveReason' | translate}}
                    </label>
                    <textarea rows="6" id="productiveReason" class="form-control" name="productiveReason"
                        [(ngModel)]="ideaConclusion.productivityVoteDescription">
                    </textarea>
                </div>

                <div class="divider"></div>

                <app-relevant-information [ideaConclusionUpdated]="IdeaConclusionUpdated"
                    [numberOfAuthors]="ideaAuthors.length"
                    (relevantInformationChange)="onRelevantInformationChange($event)">

                </app-relevant-information>


                <div class="d-flex flex-grow-1" style="gap: 30px;max-width: 394px;margin: 0 auto">
                    <a data-dismiss="modal" aria-label="Close" class="btn flex-grow-1 btn-outline-primary">Cancelar</a>
                    <a (click)="onImplementation()" class="btn flex-grow-1 btn-primary">Salvar</a>
                </div>

            </div>
        </div>
    </div>
</div>

<div class="modal-custom modal fade" id="ModalRefusal" data-keyboard="false" data-backdrop="static" role="dialog"
    aria-labelledby="modalNoteResumeLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content p-0">
            <div class="modal-header align-items-center bg-gray" style="min-height: 107px;">
                <h2 class="modal-title">Justifique o motivo da reprovação</h2>
                <a data-dismiss="modal" class="modal_close" aria-label="Close">
                    <svg-icon src="assets/svg/close-modal.svg"></svg-icon>
                </a>
            </div>
            <div class="modal-body p-3 p-md-4">
                <div class="input-material p-3 mb-4">
                    <textarea [(ngModel)]="reproveIdeaInput.motive" rows="6" class="form-control" name="type">
                    </textarea>
                    <label for="unity" class="mb-0 mr-3">Descreva aqui</label>
                </div>
                <div class="d-flex flex-grow-1" style="gap: 30px;max-width: 394px;margin: 0 auto">
                    <a data-dismiss="modal" aria-label="Close" class="btn flex-grow-1 btn-outline-primary">Cancelar</a>
                    <a (click)="reproveIdea()" class="btn flex-grow-1 btn-primary">Salvar</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-custom modal fade" id="ModalDenial" data-keyboard="false" data-backdrop="static" role="dialog"
    aria-labelledby="modalNoteResumeLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content p-0">
            <div class="modal-header align-items-center bg-gray" style="min-height: 107px;">
                <h2 class="modal-title">Mudar para reprova</h2>
                <a data-dismiss="modal" class="modal_close" aria-label="Close">
                    <svg-icon src="assets/svg/close-modal.svg"></svg-icon>
                </a>
            </div>
            <div class="modal-body p-3 p-md-4">
                <div class="input-material p-3 mb-4">
                    <p>{{'turnDisapproved' | translate}}</p>
                </div>
                <div class="d-flex flex-grow-1" style="gap: 30px;max-width: 394px;margin: 0 auto">
                    <a data-dismiss="modal" aria-label="Close" class="btn flex-grow-1 btn-outline-primary">Cancelar</a>
                    <a (click)="changeDenialStatus()" class="btn flex-grow-1 btn-primary">Confirmar</a>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="modal-custom modal fade" id="modalTranslateESPT" data-keyboard="false" data-backdrop="static" role="dialog"
    aria-labelledby="modalNoteResumeLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content p-0">
            <div class="modal-header align-items-center bg-gray" style="min-height: 107px;">
                <h2 class="modal-title">Publicação</h2>
                <a class="modal_close" (click)="closeModalTranslateESPT()">
                    <svg-icon src="assets/svg/close-modal.svg"></svg-icon>
                </a>
            </div>
            <div class="modal-body p-3 p-md-4">
                <p>
                    {{'defineInfo' | translate}}
                </p>
                <div class="row justify-content-center mb-2 text-center" style="row-gap: 10px">
                    <a href="javascript:void(0)" class="col-6 col-sm-3" (click)="clickStep(1)">
                        <span class="modal_tab" [ngClass]="{'select': step === 1}">
                            Português
                        </span>
                    </a>
                    <a href="javascript:void(0)" class="col-6 col-sm-3" (click)="clickStep(2)">
                        <span class="modal_tab" [ngClass]="{'select': step === 2}">
                            Espanhol
                        </span>
                    </a>
                </div>
                <div class="row justify-content-center mb-4 text-center" style="row-gap: 10px">
                    <div class="col-sm-6" style="z-index: 2">
                        <div class="modal_tab_bar position-relative">
                            <div class="select" [ngClass]="step === 1?'left':'right'">&nbsp;</div>
                        </div>
                    </div>
                    <div class="col-12" style="margin-top: -10px;z-index: 1">
                        <div class="modal_tab_bar position-relative" style="background-color: #707070">&nbsp;</div>
                    </div>
                </div>

                <ng-container *ngIf="step == 1">
                    <div class="input-material mb-4">
                        <textarea [(ngModel)]="modelSonsBR.title" rows="1" id="titlePT" class="form-control"
                            name="type">
                        </textarea>
                        <label for="titlePT" class="mb-0 mr-3">Titulo</label>
                    </div>
                    <div class="input-material mb-5">
                        <textarea [(ngModel)]="modelSonsBR.description" class="form-control" name="message"
                            id="descriptionPT" rows="5">
                                </textarea>
                        <label for="descriptionPT">{{'description' | translate}}</label>
                    </div>
                    <div class="input-material mb-5">
                        <textarea [(ngModel)]="modelSonsBR.implementationResume" class="form-control" name="message"
                            id="implementationResumeBR" rows="5">
                        </textarea>
                        <label for="implementationResumeBR">Resumo da implantação e ganhos</label>
                    </div>
                </ng-container>

                <ng-container *ngIf="step == 2">
                    <div class="input-material mb-4">
                        <textarea [(ngModel)]="modelSonsES.title" rows="1" id="titleES" class="form-control"
                            name="type">
                                </textarea>
                        <label for="titleES" class="mb-0 mr-3">Titulo</label>
                    </div>
                    <div class="input-material mb-5">
                        <textarea [(ngModel)]="modelSonsES.description" class="form-control" name="message"
                            id="descriptionES" rows="5">
                                </textarea>
                        <label for="descriptionES">{{'description' | translate}}</label>
                    </div>
                    <div class="input-material mb-5">
                        <textarea [(ngModel)]="modelSonsES.implementationResume" class="form-control" name="message"
                            id="implementationResumeES" rows="5">
                        </textarea>
                        <label for="implementationResumeES">Resumo da implantação e ganhos</label>
                    </div>
                </ng-container>
                <div class="row">
                    <div class="d-flex flex-grow-1" style="gap: 30px;max-width: 394px;margin: 0 auto">
                        <a class="btn flex-grow-1 btn-outline-primary" (click)="closeModalTranslateESPT()">Cancelar</a>
                        <button (click)="ideaTranslate()" [disabled]="!concludeIdea"
                            class="btn flex-grow-1 btn-primary">Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-custom modal fade" id="ModalChallenge" data-keyboard="false" data-backdrop="static" role="dialog"
    aria-labelledby="modalNoteResumeLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
        <div class="modal-content p-0">
            <div class="modal-header align-items-center bg-gray" style="min-height: 107px;">
                <h2 class="modal-title">Desafio</h2>
                <a data-dismiss="modal" class="modal_close" aria-label="Close">
                    <svg-icon src="assets/svg/close-modal.svg"></svg-icon>
                </a>
            </div>
            <div class="modal-body p-3 p-md-4">
                <p class="paragraph-challege-modal bold">Atenção!</p>
                <p class="paragraph-challege-modal">Essa ideia é um desafio, você deseja finalizar a ideia do desafio ou
                    continuar como ideia Clic?</p>
                <div class="d-flex flex-grow-1" style="gap: 30px; margin: 0 auto">
                    <a (click)="updateIdeaStatus('finished')" data-dismiss="modal" aria-label="Close"
                        class="btn flex-grow-1 btn-primary">Finalizar Ideia do Desafio</a>
                    <a (click)="onAnalysis(idea?.id)" data-dismiss="modal" aria-label="Close"
                        class="btn flex-grow-1 btn-primary">Continuar como Ideia Clic</a>
                </div>
            </div>
        </div>
    </div>
</div>